/* tslint:disable */
/* eslint-disable */
/**
 * Calvin Risk API
 * TBD
 *
 * The version of the OpenAPI document: 6.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { RiskProfileSources } from './RiskProfileSources';
import {
  RiskProfileSourcesFromJSON,
  RiskProfileSourcesFromJSONTyped,
  RiskProfileSourcesToJSON,
} from './RiskProfileSources';
import type { RiskProfileResidualRisk } from './RiskProfileResidualRisk';
import {
  RiskProfileResidualRiskFromJSON,
  RiskProfileResidualRiskFromJSONTyped,
  RiskProfileResidualRiskToJSON,
} from './RiskProfileResidualRisk';

/**
 * Adds nested create feature
 * @export
 * @interface RiskProfileCreate
 */
export interface RiskProfileCreate {
  /**
   *
   * @type {number}
   * @memberof RiskProfileCreate
   */
  readonly id: number;
  /**
   *
   * @type {number}
   * @memberof RiskProfileCreate
   */
  useCase: number;
  /**
   *
   * @type {RiskProfileSources}
   * @memberof RiskProfileCreate
   */
  sources: RiskProfileSources;
  /**
   *
   * @type {Array<RiskProfileResidualRisk>}
   * @memberof RiskProfileCreate
   */
  readonly residualRisks: Array<RiskProfileResidualRisk>;
}

/**
 * Check if a given object implements the RiskProfileCreate interface.
 */
export function instanceOfRiskProfileCreate(value: object): value is RiskProfileCreate {
  if (!('id' in value) || value['id'] === undefined) return false;
  if (!('useCase' in value) || value['useCase'] === undefined) return false;
  if (!('sources' in value) || value['sources'] === undefined) return false;
  if (!('residualRisks' in value) || value['residualRisks'] === undefined) return false;
  return true;
}

export function RiskProfileCreateFromJSON(json: any): RiskProfileCreate {
  return RiskProfileCreateFromJSONTyped(json, false);
}

export function RiskProfileCreateFromJSONTyped(json: any, ignoreDiscriminator: boolean): RiskProfileCreate {
  if (json == null) {
    return json;
  }
  return {
    id: json['id'],
    useCase: json['use_case'],
    sources: RiskProfileSourcesFromJSON(json['sources']),
    residualRisks: (json['residual_risks'] as Array<any>).map(RiskProfileResidualRiskFromJSON),
  };
}

export function RiskProfileCreateToJSON(value?: Omit<RiskProfileCreate, 'id' | 'residualRisks'> | null): any {
  if (value == null) {
    return value;
  }
  return {
    use_case: value['useCase'],
    sources: RiskProfileSourcesToJSON(value['sources']),
  };
}
